import { render } from "./SheetIcon.vue?vue&type=template&id=66999b8a"
import script from "./SheetIcon.vue?vue&type=script&lang=js"
export * from "./SheetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__